<template>
  <div class="content">
    <div class="transaction-details">
      <div class="header">
        <div>
          <div class="title">Search not found</div>
          <div
            class="title2"
            style="flex-direction: column; align-items: start"
          >
            <div>Oops! The search string you entered was:</div>
            <div>{{ searchQueryOld }}</div>
          </div>
        </div>

        <div class="search-box">
          <el-input
            placeholder="Search accounts, transactions"
            v-model="searchQuery"
            class="input-box"
            @keyup.enter.native="claimToken"
          />
          <div
            class="claim-button"
            :class="{ 'claim-button-active': searchQuery }"
            @click="claimToken"
          >
            <img src="../assets/icon_search_28@2x.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: "",
      searchQueryOld: "",
    };
  },
  mounted(){
    this.searchQueryOld = this.$route.params.id;
  },
  methods: {
  
    getAccounts2() {
      this.$api.getAccounts(this.searchQuery).then((response) => {
        let id=this.searchQuery
        this.$router.push({ name: 'Account' , params: { id }});
        window.location.reload()
        // this.generateQRCode()
        // this.getBalances();
        // this.getTransactions()
      }).catch((error)=>{
        this.txsHash(this.searchQuery)
      });
    },
    txsHash(id) {
      let params = {
        hash: id,
      };
      this.$api.txsHash(params).then((response) => {
        let id=this.searchQuery
        this.$router.push({ name: 'Transaction' , params: { id }});
      }).catch((error)=>{
        // if (id.startsWith('chno')) {
        this.$router.push({ name: 'Nothing' ,params:{id}});
      // } else {
      //   this.$router.push({ name: 'TxNothing',params:{id} });
      // }
        this.searchQueryOld = this.searchQuery;
        this.searchQuery=""
      });
    },
    claimToken() {
      if (!this.searchQuery) return;
      this.getAccounts2()
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 16px;
  text-align: left;
  .title {
    font-size: 35px;
    font-weight: 900;
    color: #000;
    margin-bottom: 8px;
  }
  .title2 {
    display: flex;
    align-items: center;
    img {
      width: 20px;
      margin-left: 4px;
    }
  }
  .search-box {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 2px;
    width: 560px;
  }
  .claim-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #cbe6de;
    color: #fff;
    border-radius: 5px;
    width: 76px;
    height: 38px;
    cursor: pointer;
    img {
      width: 30px;
    }
  }
  .claim-button-active {
    background-color: #018761 !important;
  }
}

.search-input {
  max-width: 300px;
}
.qrcode {
  img {
    width: 180px;
  }
}
.content {
  height: 100vh;
  display: flex;
  justify-content: center;
  .transaction-details {
    width: 1400px;
    max-width: 1400px;
  }
}



</style>
<style>
.table {
  border-radius: 8px 8px 0 0;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}
.table .has-gutter {
  color: #000;
  font-weight: 600;
}
.table .has-gutter th {
  background-color: #eeeeee;
}
.account-pagination .number,
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  font-size: 15px;
  width: 36px;
  height: 36px;
  max-width: 36px;
  max-height: 36px;
  line-height: 36px;
}
.account-pagination .el-pager li:not(.disabled).active {
  background-color: #38b48b !important;
}
.account-pagination .el-pager li:not(.disabled):hover {
  background-color: #38b48b !important;
  color: #fff !important;
}
.copyTips {
  border: 0 !important;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px !important;
}
.table .el-table__row .el-table__cell {
  padding: 16px 0;
  font-size: 15px;
}
.table .el-table__row:hover td.el-table__cell {
  background-color: #f2f2f2 !important;
}
</style>
